import { computeRotationBetweenTwoPerspectives } from '../math/compute-rotation-between-two-perspectives';
import { computeTweenPivot } from '../math/compute-tween-pivot';
import { cameraProps } from '../state/camera-state';

export const startCameraTween = (perspective: UI.Perspective) => {
  const { scene, camera } = window.v3d.apps[0];

  const targetLocation = scene.getObjectByName(perspective.positionOf);
  const targetLookAt = scene.getObjectByName(perspective.lookAt);

  cameraProps.startPosition.copy(camera.position);

  cameraProps.lookAtPositionStart.copy(camera.controls.orbitTarget.position);
  cameraProps.lookAtPositionCurrent.copy(cameraProps.lookAtPositionStart);
  cameraProps.lookAtPositionEnd.copy(targetLookAt.position);

  computeTweenPivot(
    cameraProps.startPosition,
    cameraProps.lookAtPositionStart,
    targetLocation.position,
    cameraProps.lookAtPositionEnd,
    cameraProps.tweenPivot
  );

  computeRotationBetweenTwoPerspectives(
    cameraProps.startPosition,
    targetLocation.position,
    cameraProps.tweenPivot,
    cameraProps.targetRotation
  );

  cameraProps.startDistance = cameraProps.startPosition.distanceTo(
    cameraProps.tweenPivot
  );
  cameraProps.targetDistance = targetLocation.position.distanceTo(
    cameraProps.tweenPivot
  );
};
